<template>
    <v-row :class="mdAndDown ? 'ma-0 mt-3' : 'ma-0'" justify="center">
        <v-col cols='12' class="pa-0" align-self="center">
            <span class="subtitleDashboard"> {{ t('labels.ociTitle') }} <span class="subtitleDashboard" style="font-size: 24px !important;" >{{ t('labels.oci') }}</span> </span>

            <IEOCardComponent  :width="330" />

            <div class="mt-8 mb-2 text-left">
                {{ t('labels.msn') }}
            </div>

            <TimeLineAlerts 
            class="text-left"
            v-if="showAlertTimeLine"
            :array-items="allAlertItems"
            :width="smAndDown ? 400 : 315"
            :height="heightTimeLine"
            :isRecurrent="true"
            />
            <span v-else class="text-left"> {{ t('noAlertsAlarmRecurren') }} </span>
        </v-col>
    </v-row>
</template>

<script setup lang="ts">
import { ref, onMounted, onBeforeUnmount } from 'vue';

/********************************
 ********** COMPONENTS **********
 *******************************/
import IEOCardComponent from '@/components/SmartLink/dashboard/IEOCardComponent.vue';
import TimeLineAlerts from '@/components/SmartLink/dashboard/TimeLineAlerts.vue';

/********************************
 ************ STORE *************
 *******************************/
import { useStore } from 'vuex';
const store = useStore();

/********************************
 ************ VUETIFY ***********
 *******************************/
import { useDisplay } from 'vuetify';
const { mdAndDown, smAndDown } = useDisplay();

/********************************
 ************ I18N **************
 *******************************/
import { useI18n } from 'vue-i18n';
const { t } = useI18n()

/********************************
 *********** SERVICES ***********
 *******************************/
import { getAlarmRecurrent } from '@/services/Smartlink/Principal';

/********************************
 ********** CONSTANTES **********
 *******************************/
import { LABELS } from '@/constants/labels';


const allAlertItems     = ref([]);
const showAlertTimeLine = ref(false);
const heightTimeLine    = ref(492);

/**
 * Captura los valores de la API: "getAlarmRecurrentToDashBoard"
 */
const getAlarmToDashBoard = async () => {

    showAlertTimeLine.value = false;
    allAlertItems.value = [];

    const allData = await getAlarmRecurrent()
    
    if( allData.status === 400 ){
        showAlertTimeLine.value = allData.showGraphs
        store.commit('showSnackBar', {type: LABELS.error, msg: t('snackbar.errorApis'), valor : true});
    }
    if( allData.status === 200 ){
        showAlertTimeLine.value = allData.showGraphs
        allAlertItems.value = allData.data
    }
    
}


let intervaloId:any = null;

async function iniciarVista() {
    intervaloId = setInterval(async() => {
        await getAlarmToDashBoard();
    }, 60000);
}

async function cambiarDeVista() {
    if (intervaloId) {
        clearInterval(intervaloId);
        intervaloId = null; // Buena práctica
    }    
}


onMounted(async() => {
    iniciarVista();
    await getAlarmToDashBoard();
})

onBeforeUnmount(() => {
    cambiarDeVista();
});

</script>
